<div class="search-container fwc-row">
  <label for="search_accounts" class="sr-only">Search account filter</label>
  <select name="searchAccounts" id="search_accounts" [(ngModel)]="searchAccounts" aria-label="Filter search by account">
    <option selected value="All">Search All Accounts</option>
    @for (option of searchOptions; track option) {
      <option [value]="option.id">{{option.label}}</option>
    }
  </select>
  <div class="fwc-input fwc-input-icon">
    <span class="fwc-icon fwc-icon-search search-icon" (click)="searchStudent()"></span>
    <input
      autocomplete="off"
      name="member-search"
      id="member-search"
      type="text"
      [(ngModel)]="searchTerm"
      (keyup.enter)="searchStudent()"
      placeholder="Search for student"
      />
  </div>
</div>

